var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('next-steps-base-card',{attrs:{"title":"וובינר: מה זה בעצם תזרים ואיך להתשמש בו בצורה הכי נכונה","button-text":"להרשמה לוובינר","description":"שעה, מפגש אונליין","action-key":_vm.actionKey},on:{"click":_vm.openWebinarSignup}})}
var staticRenderFns = []

export { render, staticRenderFns }